import { type MenuItem, ProfileMenuGroup } from 'shared/types'

export type DigitalSettingsProps = {
  isPaymentMethodEnabled?: boolean
  isRecurrenceSettingsEnabled?: boolean
  isFeatureSettingsEnabled?: boolean
  isOneStone?: boolean
  isAffiliationsEnabled?: boolean
  isBoletoConfigEnabled?: boolean
  isAttemptConfigEnabled?: boolean
  hasLinkPoi?: boolean
  hasEcommercePoi?: boolean
}

export function digitalSettingsProfileMenu({
  isPaymentMethodEnabled = false,
  isRecurrenceSettingsEnabled = false,
  isFeatureSettingsEnabled = false,
  isOneStone = false,
  isAffiliationsEnabled = false,
  isBoletoConfigEnabled = false,
  isAttemptConfigEnabled = false,
  hasLinkPoi = false,
  hasEcommercePoi = false
}: DigitalSettingsProps = {}): MenuItem[] {
  return [
    {
      order: 9,
      label: 'Formas de pagamento',
      icon: 'money-deposit',
      show: isPaymentMethodEnabled && hasEcommercePoi,
      path: '/vendas-online/formas-de-pagamento',
      active: (route: string) => ['/vendas-online/formas-de-pagamento'].includes(route),
      group: ProfileMenuGroup.ONLINE_SALES
    },
    {
      order: 9,
      label: 'Afiliações',
      icon: 'link',
      show: isAffiliationsEnabled,
      path: '/vendas-online/afiliacoes',
      active: (route: string) => ['/vendas-online/afiliacoes'].includes(route),
      group: ProfileMenuGroup.ONLINE_SALES
    },
    {
      order: 9,
      label: 'Venda por assinatura',
      icon: 'calendar-money',
      show: isRecurrenceSettingsEnabled && (isBoletoConfigEnabled || isAttemptConfigEnabled) && hasEcommercePoi,
      path: '/vendas-online/venda-por-assinatura',
      active: (route: string) => ['/vendas-online/venda-por-assinatura'].includes(route),
      group: ProfileMenuGroup.ONLINE_SALES
    },
    {
      order: 9,
      label: 'Funcionalidades',
      icon: 'action-settings-sliders',
      show: isFeatureSettingsEnabled && hasEcommercePoi,
      path: '/vendas-online/funcionalidades',
      active: (route: string) => ['/vendas-online/funcionalidades'].includes(route),
      group: ProfileMenuGroup.ONLINE_SALES
    },
    {
      order: 9,
      label: 'Link de pagamento',
      icon: 'paper-plane',
      show: isOneStone && hasLinkPoi,
      path: '/vendas-online/link-de-pagamento',
      active: (route: string) => ['/vendas-online/link-de-pagamento'].includes(route),
      group: ProfileMenuGroup.ONLINE_SALES
    },
    {
      order: 9,
      label: 'Vendas',
      icon: 'shop',
      show: hasEcommercePoi,
      path: '/vendas-online/vendas-de-teste',
      active: (route: string) =>
        ['/vendas-online/vendas-de-teste', '/sales/test-sales'].some(
          testSalesRoute => route === testSalesRoute || route.startsWith(`${testSalesRoute}/`)
        ),
      badge: { label: 'Teste', voice: 'warning' },
      group: ProfileMenuGroup.SALES_TEST_ENVIRONMENT
    }
  ]
}
